export enum Mode {
  Resting,
  Requesting,
  Requested,
  Confirming,
  Confirmed
}
